var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoColorsWithWhiteText(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 408.56 141.86",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{clip-path:url(#clip-path);}.cls-3{fill:#fff;}.cls-4{fill:url(#D\xE9grad\xE9_sans_nom_2);}.cls-5{fill:url(#D\xE9grad\xE9_sans_nom_2-2);}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path",
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 424.82,
    height: 142.86
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_2",
    x1: -695.36,
    y1: 609.84,
    x2: -694.36,
    y2: 609.84,
    gradientTransform: "translate(45880.88 -59963.29) rotate(-11.4) scale(81.67)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000bff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7fffbb"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_2-2",
    x1: -696.28,
    y1: 610.16,
    x2: -695.28,
    y2: 610.16,
    gradientTransform: "translate(50698.37 -66318.94) rotate(-11.4) scale(90.24)",
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_2"
  }))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "logo-colors-with-white-text") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Calque_2",
    "data-name": "Calque 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Calque_1-2",
    "data-name": "Calque 1"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M237.68,33.29v84.26h-.44L180.59,66.4l.33,47.85H164.75V30.1h.66L222,82l-.33-48.73Z",
    transform: "translate(-0.5 -0.5)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M259.19,53.31a41.91,41.91,0,0,1,15.07-15.23,40.35,40.35,0,0,1,41.25,0,42.93,42.93,0,0,1,15.18,15.23,40.41,40.41,0,0,1,0,41.25,42.27,42.27,0,0,1-15.18,15,41.21,41.21,0,0,1-41.31,0,41.41,41.41,0,0,1-15-15,41,41,0,0,1,0-41.25Zm14.3,33.55a25.22,25.22,0,0,0,9.13,9.41,24.42,24.42,0,0,0,12.81,3.46,23.17,23.17,0,0,0,12.43-3.46,24.57,24.57,0,0,0,8.8-9.35,28.15,28.15,0,0,0-.11-26.24,25.14,25.14,0,0,0-9-9.4,24.59,24.59,0,0,0-25.19,0,25.09,25.09,0,0,0-9,9.4,26.72,26.72,0,0,0-3.3,13.2A25.9,25.9,0,0,0,273.49,86.86Z",
    transform: "translate(-0.5 -0.5)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M407.52,33.29v15.4H368.25V66H403v15.4H368.25V98.85h40.81v15.4H352.3v-81ZM384.09,28h-9.35l8.58-14.85h17.05Z",
    transform: "translate(-0.5 -0.5)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M110,15.48l-5.09-3.18c4.34-6.13,6.66-10.65,14-11.53,4-.12,7.13,3.18,8,5.65a21.5,21.5,0,0,1,1.34,8.26,54.92,54.92,0,0,1-.31,5.49l-11,106.57h0c-.5,7.77-5.2,15.55-13.53,15.62-5-.07-9.1-2.62-12.81-6.34h0l-15.6-15.77h0c-7.7-7.84-11.47-18.72-11.5-29.48a40.45,40.45,0,0,1,5.84-21.34L104.87,12.3,110,15.48l5.09,3.17L79.41,75.78a28.49,28.49,0,0,0-4,15c0,7.93,2.94,15.94,8,21L99,127.58h0c2.38,2.45,4.15,2.85,4.28,2.78s.11.09.23-.24a9.72,9.72,0,0,0,1.37-4.61h0l11-106.57a42.26,42.26,0,0,0,.25-4.26,11.72,11.72,0,0,0-.39-3.58l2.06-.87-1.38,1.68a2.12,2.12,0,0,1-.68-.81l2.06-.87-1.38,1.68L118.84,9v3.81a4,4,0,0,1-2.42-.86L118.84,9v1.56l1.13,2a2.74,2.74,0,0,1-1.13.21V10.52l1.13,2c-.2,0-2.52,2.11-4.92,6.09Z",
    transform: "translate(-0.5 -0.5)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M18.66,127.39l5.09,3.17c-4.33,6.13-6.65,10.66-14,11.53-3.95.12-7.13-3.18-7.94-5.65A21.25,21.25,0,0,1,.5,128.18a52,52,0,0,1,.31-5.48h0l11-106.58C12.3,8.35,17,.57,25.32.5c4.95.07,9.1,2.63,12.82,6.35h0L53.73,22.61h0c7.7,7.84,11.48,18.72,11.5,29.48a40.3,40.3,0,0,1-5.84,21.35L23.75,130.56h0l-5.09-3.17-5.09-3.18L49.21,67.08a28.3,28.3,0,0,0,4-15c0-7.92-2.94-15.94-8-21h0L29.61,15.28h0c-2.38-2.44-4.15-2.85-4.29-2.78s-.11-.08-.22.25a9.43,9.43,0,0,0-1.37,4.6l-11,106.58h0c-.16,1.64-.24,3.07-.24,4.25a10.9,10.9,0,0,0,.39,3.58l-2.07.87L12.2,131a2.33,2.33,0,0,1,.69.8l-2.07.87L12.2,131,9.78,133.9v-3.81a3.93,3.93,0,0,1,2.42.87L9.78,133.9v-1.55l-1.13-2a2.67,2.67,0,0,1,1.13-.22v2.26l-1.13-2c.2,0,2.52-2.11,4.92-6.1h0Z",
    transform: "translate(-0.5 -0.5)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoColorsWithWhiteText);
export default __webpack_public_path__ + "static/media/logo-colors-with-white-text.9d5bb4224b59893be13332b2b9c9e910.svg";
export { ForwardRef as ReactComponent };